import React from 'react';
import MuiGrid from '@material-ui/core/Grid';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { useRegister, useRegisterDetail } from './register-hooks';
import { GridUpperPanel } from './register-upper-panel';
import { GridCentralPanel } from './register-central-panel';
import { GridRightPanel } from './register-right-panel';
import { OriginatorContextProvider } from './register-context';
import { RegisterDetailComponent } from './register-detail';
import { GridLeftPanelV2 } from './register-left-panel-v2';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridRoot: {
      minHeight: 'calc(100vh - 80px)',
    },
    gridCentralRight: {
      minHeight: 'calc(100vh - 140px)',
    },
    gridCenterRoot: {
      gridGap: theme.spacing(3),
    },
  })
);

export const RegisterGrid: React.FC<{ detailView?: boolean }> = ({
  detailView,
}) => {
  const classes = useStyles();
  const { letters, detailId, handleDetailId } = useRegister(!!detailView);
  const detail = useRegisterDetail();

  return (
    <OriginatorContextProvider originator={detail}>
      <MuiGrid container className={classes.gridRoot}>
        <MuiGrid item md={3} xs={12} className={classes.gridRoot}>
          <GridLeftPanelV2 letters={letters} detailView={!!detailView} />
        </MuiGrid>
        <MuiGrid item md={9} xs={12} className={classes.gridRoot}>
          <MuiGrid container>
            <MuiGrid item xs={12}>
              <GridUpperPanel />
            </MuiGrid>
            <MuiGrid item md={9} xs={12} className={classes.gridCentralRight}>
              {detailView ? (
                <div
                  style={{
                    margin: 8,
                    overflow: 'auto',
                    background: '#fff',
                    border: '1px solid rgba(224, 224, 224, 1)',
                    borderTop: 'none',
                  }}
                >
                  <RegisterDetailComponent detail={detail} />
                </div>
              ) : (
                <GridCentralPanel
                  detailId={detailId}
                  detail={detail}
                  handleDetailId={handleDetailId}
                />
              )}
            </MuiGrid>
            <MuiGrid item md={3} xs={12} className={classes.gridCentralRight}>
              <GridRightPanel detail={detail} />
            </MuiGrid>
          </MuiGrid>
        </MuiGrid>
      </MuiGrid>
    </OriginatorContextProvider>
  );
};
